import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { SelectField, MenuItem } from "material-ui"
import AvailablePayClasses from "./AvailablePayClasses"
import { IPayClass } from "../../../models"
interface IProps {
    readonly?: boolean
    defaultPayClass: IPayClass
    availablePayClasses: IPayClass[]
    availablePayTypeIds: string[]
    handleChange(availablePayClasses: IPayClass[], defaultPayClass: IPayClass, error: boolean)
}
interface IState {
    defaultPayClassId: string
    errorDefaultPayClass: string
    availablePayClasses: IPayClass[]
}

export default class PayClass extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            defaultPayClassId: props.defaultPayClass ? props.defaultPayClass.Id : null,
            errorDefaultPayClass: "",
            availablePayClasses: props.availablePayClasses || []
        }
        autobind(this)
    }

    checkValidate() {
        let isValid = true
        if (!this.state.defaultPayClassId) {
            this.setState({ errorDefaultPayClass: strings.This_field_is_required })
            isValid = false
        }
        else {
            if (!this.state.availablePayClasses.find(item => item.Id === this.state.defaultPayClassId)) {
                this.setState({ errorDefaultPayClass: strings.This_field_is_required })
                isValid = false
            }
            else {
                this.setState({ errorDefaultPayClass: "" })
            }
        }
        return isValid
    }

    handleChange() {
        const isValid = this.checkValidate()
        const defaultPayClass = this.state.availablePayClasses.find(item => item.Id === this.state.defaultPayClassId)
        this.props.handleChange(this.state.availablePayClasses, defaultPayClass, !isValid)
    }

    render() {
        return (
            <div>
                <SelectField
                    data-intercom-target={"Payclass-Select-DefaultPayclass"}
                    floatingLabelText={strings.Default_PayClass}
                    value={this.state.defaultPayClassId}
                    onChange={(event, index, value) => this.setState({ defaultPayClassId: value }, () => this.handleChange())}
                    errorText={this.state.errorDefaultPayClass}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                    disabled={this.props.readonly}
                >
                    {this.state.availablePayClasses.map((item, i) =>
                        <MenuItem
                            key={i}
                            value={item.Id}
                            primaryText={item.Name}
                        />
                    )}
                </SelectField>
                <div style={{ marginTop: 10 }}>
                    <AvailablePayClasses
                        readonly={this.props.readonly}
                        payClasses={this.state.availablePayClasses}
                        availablePayTypeIds={this.props.availablePayTypeIds}
                        handleChange={availablePayClasses => this.setState({ availablePayClasses }, () => this.handleChange())}
                    />
                </div>
            </div>
        )
    }
}